/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Improve_Sleep_QuestionInputs */

const en_us2_improve_sleep_question = /** @type {(inputs: Improve_Sleep_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do you usually sleep?`)
};

const pt_br2_improve_sleep_question = /** @type {(inputs: Improve_Sleep_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como você costuma dormir?`)
};

const es_419_improve_sleep_question = /** @type {(inputs: Improve_Sleep_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo sueles dormir?`)
};

const pt_pt2_improve_sleep_question = /** @type {(inputs: Improve_Sleep_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como costumas dormir?`)
};

const fr_fr2_improve_sleep_question = /** @type {(inputs: Improve_Sleep_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment dors-tu d'habitude ?`)
};

const de_de2_improve_sleep_question = /** @type {(inputs: Improve_Sleep_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie schläfst du normalerweise?`)
};

const it_it2_improve_sleep_question = /** @type {(inputs: Improve_Sleep_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come dormi di solito?`)
};

/**
* | output |
* | --- |
* | "How do you usually sleep?" |
*
* @param {Improve_Sleep_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const improve_sleep_question = /** @type {((inputs?: Improve_Sleep_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Improve_Sleep_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_improve_sleep_question(inputs)
	if (locale === "es-419") return es_419_improve_sleep_question(inputs)
	if (locale === "pt-PT") return pt_pt2_improve_sleep_question(inputs)
	if (locale === "fr-FR") return fr_fr2_improve_sleep_question(inputs)
	if (locale === "de-DE") return de_de2_improve_sleep_question(inputs)
	if (locale === "it-IT") return it_it2_improve_sleep_question(inputs)
	return en_us2_improve_sleep_question(inputs)
});
export { improve_sleep_question as "improve.sleep.question" }